import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Login.css';
import logoImg from '../../static/logo.svg';

export const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');

    const handleEmailClick = () => {
        // Create a mailto link with the user's email as part of the body
        const body = `Hi,\n\n I need to reset my password.\n\n My email address: ${email} \n\n Thank you!`;
        const mailtoLink = `mailto:contact@childstorytimetime.ai?subject=Password Reset Request&body=${body}`;
        window.location.href = mailtoLink;
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">
                    <div className="login-logo">
                        <img src={logoImg} alt="Logo" className="logo-img" />
                        <div className="logo-text">
                            <span className="logo-text-primary">Child</span>
                            <span className="logo-text-secondary">Story Time</span>
                        </div>
                    </div>
                    
                    <h2 className="login-title">Forgot Password?</h2>
                    <p className="login-subtitle">Please enter your email below and contact our support team.</p>
                    
                    <div className="form-group">
                        <label>Email address</label>
                        <div className="input-wrapper">
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email address"
                                required
                            />
                            <i className="email-icon"></i>
                        </div>
                    </div>

                    <button 
                        onClick={handleEmailClick} 
                        className="login-button"
                    >
                        Contact Support
                    </button>
                    
                    <p className="login-subtitle" style={{ marginTop: '20px', fontSize: '14px' }}>
                        Click the button above to send an email to contact@childstorytimetime.ai with your email address.
                    </p>
                    
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <Link to="/login" className="back-link">
                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                                ← Back to Log in
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}; 